
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/web-application-development",
      function () {
        return require("private-next-pages/us/web-application-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/web-application-development"])
      });
    }
  